<template>
  <div>
    <video :id="'video'+ deviceId + refId" v-if="!isIframe" muted controls autoplay playsinline style="  width: 100%;
    height: 100%;
    background: black;
    object-fit: fill; position: absolute; z-index: 1;"></video>
    <iframe 
      :src    = "linkStream"
      v-if    = "isIframe" 
      allow   = "autoplay"
      :id     = "'iframe' + deviceId + refId" 
      style   = "width:100%; height:100%; object-fit: fill; position: absolute; z-index: 1;"

  ></iframe>
  </div>
</template>

<script>
export default {
  name : "StreamWebRTC",
  props : ["linkStream", "deviceId", "refId"],
  data() {
    return {
      isIframe : false,
      pc: null,
      restartTimeout: null,
      eTag: '',
      headerLocation:'',
      offerData: {},
      queuedCandidates: [],
      timeRestart : 15000,
    };
  },
  mounted() {
    this.start();
  },
  watch:{
    linkStream(val, oldVal){      
      if(val != oldVal){
        this.start();
      }
    }
  },
  beforeDestroy(){
    this.stop();
  },
  methods: {
    start() {
      this.stop();
      // console.log("requesting ICE servers", this.linkStream);
      // 'https://control.guardian.imperium.pe/webrtc/ESTACIONAMIENTO-cad14553-724c-40b5-87d8-7f94f186b0cc/'
      // console.log("options start ", new URL('whep', this.linkStream) + window.location.search)
      fetch(new URL('whep', this.linkStream) + window.location.search, {
        method: 'OPTIONS',
      })
        .then((res) => this.onIceServers(res))
        .catch((err) => {
          // console.log('error: ' + err);
          this.scheduleRestart();
        });
    },
    stop(){
      if(this.restartTimeout){        
        // console.log("sTOP ")
        clearTimeout(this.restartTimeout);
        this.restartTimeout=null;
      }
    },
    onIceServers(res) {
      this.pc = new RTCPeerConnection({
        iceServers: this.linkToIceServers(res.headers.get('Link')),
      });      

      const direction = "sendrecv";
      this.pc.addTransceiver("video", { direction });
      this.pc.addTransceiver("audio", { direction });

      this.pc.onicecandidate = (evt) => this.onLocalCandidate(evt);
      this.pc.oniceconnectionstatechange = () => this.onConnectionState();

      this.pc.ontrack = (evt) => {
        //console.log("new track:", evt.track.kind);
        const elVideo = document.getElementById("video"+ this.deviceId + this.refId);
        if (elVideo) {
          elVideo.srcObject = evt.streams[0]
        }
      };

      this.pc.createOffer()
        .then((offer) => this.onLocalOffer(offer));
    },
    onLocalOffer(offer) {
      this.offerData = this.parseOffer(offer.sdp);
      this.pc.setLocalDescription(offer);

      // console.log("sending offer",  new URL('whep', this.linkStream) + window.location.search);
      // 'https://control.guardian.imperium.pe/webrtc/ESTACIONAMIENTO-cad14553-724c-40b5-87d8-7f94f186b0cc/'
      fetch(new URL('whep', this.linkStream) + window.location.search, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/sdp',
        },
        body: offer.sdp,
      })
        .then((res) => {
          if (res.status !== 201) {
            throw new Error('bad status code');
          }
          this.eTag = res.headers.get('E-Tag') || res.headers.get("etag");
          this.headerLocation = "";
          this.headerLocation = res.headers.get("location") || res.headers.get("Location") ;//.split('whep')[1];
          //console.log(" E- TAG ", res.headers.get("etag"), res.headers.get("e-tag"))
          // console.log("res location ", res.headers.get("location"), " tag ", this.eTag, res.headers, res )          
          //console.log(" onLocalOffer == ", res.headers.get("location") , res.headers.get("Location"))
          // console.log("this.headerLocation  ", this.headerLocation )
          if (!this.headerLocation) {            
            console.warn("No contiene location ")
          }else{
            if (this.headerLocation.includes('whep/')) {
              this.headerLocation = 'whep/'+this.headerLocation.split('whep/')[1]
            }
          }
          return res.text();
        })
        .then((sdp) => this.onRemoteAnswer(new RTCSessionDescription({
          type: 'answer',
          sdp,
        })))
        .catch((err) => {
          // console.log('error: ' + err);
          this.scheduleRestart();
        });
    },
    onConnectionState() {
      if (this.restartTimeout !== null) {
        return;
      }

      //console.log("peer connection state: ", this.pc.iceConnectionState, " of ", this.linkStream);

      switch (this.pc.iceConnectionState) {
        case "disconnected":
          this.scheduleRestart();
      }
    },
    onRemoteAnswer(answer) {
      if (this.restartTimeout !== null) {
        return;
      }

      this.pc.setRemoteDescription(new RTCSessionDescription(answer));

      if (this.queuedCandidates.length !== 0) {
        this.sendLocalCandidates(this.queuedCandidates);
        this.queuedCandidates = [];
      }
    },
    onLocalCandidate(evt) {
      if (this.restartTimeout !== null) {
        return;
      }

      if (evt.candidate !== null) {
        if (this.eTag === '') {
          this.queuedCandidates.push(evt.candidate);
        } else {
          this.sendLocalCandidates([evt.candidate])
        }
      }
    },
    sendLocalCandidates(candidates) { // 'https://control.guardian.imperium.pe/webrtc/ESTACIONAMIENTO-cad14553-724c-40b5-87d8-7f94f186b0cc/'

      //console.log("send sendLocalCandidates ",  this.linkStream, " | ",  this.headerLocation, " | ", window.location.search, " tag ", this.eTag ) // this.headerLocation/*
      if (this.headerLocation) {
        /*window.location.search*/
        // console.log("------------------- ", new URL(this.linkStream) + this.headerLocation)
        fetch(new URL(this.linkStream) + this.headerLocation, { //"whep"
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/trickle-ice-sdpfrag',
            'If-Match': this.eTag,
          },
          body: this.generateSdpFragment(this.offerData, candidates),
        })
          .then((res) => {
            if (res.status !== 204) {
              throw new Error('bad status code');
            }
          })
          .catch((err) => {
            // console.log('error: ' + err);
            this.scheduleRestart();
          });
      }else{
        console.warn("Requiered Location for webRTC ", this.linkStream, this.headerLocation)
      }
    },
    scheduleRestart() {
      // console.log("RESTART ")
      if (this.restartTimeout !== null) {
        return;
      }

      if (this.pc !== null) {
        this.pc.close();
        this.pc = null;
      }

      this.restartTimeout = window.setTimeout(() => {
        clearTimeout(this.restartTimeout);
        this.restartTimeout = null;
        this.start();
      }, this.timeRestart); // this.restartPause

      this.eTag = '';
      this.queuedCandidates = [];
    },
    linkToIceServers(links) {
      return (links !== null) ? links.split(', ').map((link) => {
        const m = link.match(/^<(.+?)>; rel="ice-server"(; username="(.*?)"; credential="(.*?)"; credential-type="password")?/i);
        const ret = {
          urls: [m[1]],
        };

        if (m[3] !== undefined) {
          ret.username = this.unquoteCredential(m[3]);
          ret.credential = this.unquoteCredential(m[4]);
          ret.credentialType = "password";
        }

        return ret;
      }) : [];
    },
    unquoteCredential(v) {
      return JSON.parse(`"${v}"`);
    },
    parseOffer(offer) {
      const ret = {
        iceUfrag: '',
        icePwd: '',
        medias: [],
      };

      for (const line of offer.split('\r\n')) {
        if (line.startsWith('m=')) {
          ret.medias.push(line.slice('m='.length));
        } else if (ret.iceUfrag === '' && line.startsWith('a=ice-ufrag:')) {
          ret.iceUfrag = line.slice('a=ice-ufrag:'.length);
        } else if (ret.icePwd === '' && line.startsWith('a=ice-pwd:')) {
          ret.icePwd = line.slice('a=ice-pwd:'.length);
        }
      }

      return ret;
    },
    generateSdpFragment(offerData, candidates) {
      const candidatesByMedia = {};
      for (const candidate of candidates) {
        const mid = candidate.sdpMLineIndex;
        if (candidatesByMedia[mid] === undefined) {
          candidatesByMedia[mid] = [];
        }
        candidatesByMedia[mid].push(candidate);
      }

      let frag = 'a=ice-ufrag:' + offerData.iceUfrag + '\r\n'
        + 'a=ice-pwd:' + offerData.icePwd + '\r\n';

      let mid = 0;

      for (const media of offerData.medias) {
        if (candidatesByMedia[mid] !== undefined) {
          frag += 'm=' + media + '\r\n'
            + 'a=mid:' + mid + '\r\n';

          for (const candidate of candidatesByMedia[mid]) {
            frag += 'a=' + candidate.candidate + '\r\n';
          }
        }
        mid++;
      }

      return frag;
    },
  }
};
</script>

<style scoped>
  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    overflow: hidden;
  }
  #video {

}
</style>
